module.exports = __webpack_public_path__ + "assets/img/mecha4-8d2382a5.jpg";